module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/ListIconGray.f8ec93a0.svg";